import React, { useState } from 'react';
import Navbar from '../Components/Navbar'
import img from '../Assets/hand.png'
import year from '../Assets/year.png'
import img2 from '../Assets/Group 1000001783.png'
import globe from '../Assets/globe.png'
import Footer from '../Components/Footer'
import box from '../Assets/donate.png'
import f1 from '../Assets/Background-1.png'
function Ngo() {
    const accordionData = [
        { title: "Education and training program", content: "Our Education and Training Program is designed to equip individuals with the knowledge, skills, and opportunities they need to thrive." },
        { title: "Promoting wellness and security", content: "Content for item 2" },
        { title: "Responding swiftly to disasters", content: "Content for item 3" },
        { title: "Brighter tomorrow", content: "Content for item 4" },

      ];
    
      const [openIndex, setOpenIndex] = useState(null); // State to track the open accordion index
    
      const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index); // Toggle the open/close state
      };
    
  return (
    <>
        <Navbar/>
        <div className='banner banner5'>
    <h2 data-aos="fade-right">NGO</h2>

    <p data-aos="fade-right">Home / NGO</p>
   
    </div>
    <div className='ngo'>
    <div className='ngo-left'>
    <p data-aos="fade-right">Nikhil Ranjan Foundation</p>
    <h3 data-aos="fade-right">Embracing discomfort, we propel
towards meaningful transformation,
shaping a brighter future with every
courageous decision we make.</h3>

    </div>
    <div className='ngo-right'>
<img data-aos="zoom-in" src={img}/>
</div>

    </div>
    <div className='exps'>
    <div className='exps-left'>
    <img src={year}/>

</div>
 <div className='exps-right'>
 <div className='exp-text'>
 <div className='exp-text1'>
 <p>At Nikhil Ranjan Foundation, our mission is to make a positive impact in the lives of those who need it most. Founded in 2024, our organization is dedicated to providing education and resources to underprivileged communities, empowering individuals to break the cycle of poverty and build sustainable futures.</p>
 </div>
 <div className='exp-text1'>
 <p>Through our various initiatives, we focus on education, healthcare, and community development, ensuring that every individual has the opportunity to thrive. Our approach combines immediate relief with long-term solutions, creating lasting change in the communities we serve.</p>
 </div>

 </div>
 <div className='exp-count'>
<div className='exp-count1'>
    <h4>250<span>+</span></h4>
    <p>Active Volunteers
across
India</p>
</div>
<div className='exp-count1'>
    <h4>50<span>+</span></h4>
    <p>Communities
Impacted
Nationwide</p>
</div>
<div className='exp-count1'>
    <h4>1<span>+</span></h4>
    <p>Year of
Dedicated
Service</p>
</div>
 </div>

</div>
    </div>
    <div className='donate' data-aos="zoom-in">
    <div className='donate-div'>
  <div>

  <h3>Your donation
<br/>
empowers those
<br/>

in need</h3>
<br/>
<br/>
<div className='donate-section'>
    <img src={img2}/>
    <p>More than 5 million
<br/>
people from around
<br/>
the world have joined
<br/>
and helped our
community.</p>
</div>
  </div>
<div className='donation-box-img'>
  <img src={box}/>

</div>

<button>Donate now</button>


</div>

    </div>
    <div className='mission'>
    <h2>The mission of our
    organization</h2>
    <br/>

    <h4>Explore our diverse range of programs and initiatives aimed at fostering<br/>
    positive change and making a tangible impact in communities worldwide.</h4>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
<div className='globe'>
<div className='globe-left'>
<div>







{accordionData.map((item, index) => (
        <div key={index} className="accordion-item">
          <div
            className="accordion-header"
            onClick={() => toggleAccordion(index)}
          >
            <h3>{item.title}</h3>
            <span>{openIndex === index ? '-' : '+'}</span>
          </div>
          {openIndex === index && (
            <div className="accordion-content">
              <p>{item.content}</p>
            </div>
          )}
        </div>
      ))}















</div>
</div>
<div className='globe-right'>
<img src={globe}/>
</div>
</div>



    </div>
    <div className='cause '>
    <div className='cause-left'>
<h3>How can your
support our
cause?</h3>
    

    </div>
    <div className='cause-right'>
    <div className='cause-cards'>
   <div>
   <div className='cause-card'>
<img src={f1} alt="Financial Support"/>
<br/>
<br/>
<h3>Financial Support</h3>
<p>Your generous donations help us fund essential programs, provide resources, and expand our reach to more communities in need across India.</p>
</div>
   </div>
   <div>
   <div className='cause-card'>
<img src={f1} alt="Volunteer"/>
<br/>
<br/>
<h3>Volunteer</h3>
<p>Join our team of dedicated volunteers and contribute your time and skills to make a direct impact in the lives of those we serve.</p>
</div>
   </div>
   <div>
   <div className='cause-card'>
<img src={f1} alt="Corporate Partnership"/>
<br/>
<br/>
<h3>Corporate Partnership</h3>
<p>Partner with us to create meaningful CSR initiatives that drive social change and make a lasting difference in communities.</p>
</div>
   </div>
   <div>
   <div className='cause-card'>
<img src={f1} alt="Awareness"/>
<br/>
<br/>
<h3>Spread Awareness</h3>
<p>Help us amplify our message by sharing our mission with your network and raising awareness about the issues we address.</p>
</div>
   </div>
    </div>

    

</div>


    </div>
    <Footer/>
    </>
  )
}

export default Ngo